import React, { Suspense } from 'react';
import './assets/styles/globals.scss';
import './App.scss'
import { Routes } from 'react-router-dom';
import store from './redux/store';
import { Provider } from "react-redux";
import { generateRoutes, routes } from './routes';
import Toaster from './components/Toaster/Toaster';

interface AppProps {
  sidebarVisible?: boolean;
  fontFamily?: string;

};

const App: React.FC<AppProps> = () => {


  return (
    // <Routes>
    //   <Route path='/dashboard' element={<HomeLayout currentIndex={0}/>}/>
    //   <Route path="/" element={<Navigate replace to="/projects" />} />
    //   <Route path='/tasks' element={<HomeLayout currentIndex={1}/>}/>
    //   <Route path='/projects' element={<HomeLayout currentIndex={2}/>}/>
    //   <Route path="/projects/:pId" element={<ProjectLayout><ProjectSlide/></ProjectLayout>} />
    //   <Route path="/projects/:pId/overview" element={<ProjectLayout><CodeBase/></ProjectLayout>}/>
    //   <Route path='/settings' element={<HomeLayout currentIndex={3}/>}/>
    //   <Route path='/help-support' element={<HomeLayout currentIndex={4}/>}/>
    // </Routes>
    <Provider store={store}>
      <Suspense>
        <Routes>{generateRoutes(routes)}</Routes>
      </Suspense>
      <Toaster />
    </Provider>
  )
};

export default App;
